import { 
    AUTH_LOGIN, 
    AUTH_LOGOUT, 
    AUTH_CHECK, 
    AUTH_ERROR, 
    GOOGLE_ACCOUNT_AUTH, 
    GET_CSRF_TOKEN, 
    AUTH_GET_PERMISSION,
} from './auth';
import { fetchJson } from './util/fetch';
import { loginBackendPath, logoutBackendPath, csrfTokenBackendPath } from './routes/auth/urls'
import { adminUserPermissionBackendPath } from './routes/user/urls'


export default (apiUrl, httpClient = fetchJson) => async (type, params) => {
    if (type === GET_CSRF_TOKEN) {
        const options = {};
        options.method = 'GET';
        fetchJson(`${apiUrl}${csrfTokenBackendPath}`, options);
        return Promise.resolve();
    }
    if (type === GOOGLE_ACCOUNT_AUTH) {
        const auth2 = window.gapi.auth2.getAuthInstance();

        return auth2.signIn(params)
            .then((res) => {
                /*
                 The section below is commented for future reference
                 */
                // const basicProfile = res.getBasicProfile();
                // const authResponse = res.getAuthResponse();
                // res.googleId = basicProfile.getId();
                // res.tokenObj = authResponse;
                // res.tokenId = authResponse.id_token;
                // res.accessToken = authResponse.access_token;
                // res.profileObj = {
                //     googleId: basicProfile.getId(),
                //     imageUrl: basicProfile.getImageUrl(),
                //     email: basicProfile.getEmail(),
                //     name: basicProfile.getName(),
                //     givenName: basicProfile.getGivenName(),
                //     familyName: basicProfile.getFamilyName(),
                // };
                const authResponse = res.getAuthResponse();
                const basicProfile = res.getBasicProfile();
                return {'tokenId': authResponse.id_token, 'email': basicProfile.getEmail()}
        })

    }
    if (type === AUTH_LOGIN) {
        const { tokenId, email } = params;
        const options = {};
        options.method = 'POST';
        options.body = JSON.stringify({token_id:tokenId});

        localStorage.setItem('username', email);
        return fetchJson(`${apiUrl}${loginBackendPath}`, options);
    }
    if (type === AUTH_GET_PERMISSION) {
        try {
            const response = await fetchJson(
                `${apiUrl}${adminUserPermissionBackendPath}`, 
                { method: 'GET' }
            );
            if (
                response
                && response.json
            ) {
                const { is_superuser, permissions } = response.json;
                localStorage.setItem('user_permissions', JSON.stringify(permissions));
                localStorage.setItem('is_superuser', is_superuser);
            } else {
                localStorage.setItem('user_permissions', JSON.stringify([]));
            }
        } catch (error) {
            localStorage.setItem('user_permissions', JSON.stringify([]));
        }

        return Promise.resolve();
    }
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('username');
        localStorage.removeItem('is_superuser');
        localStorage.removeItem('user_permissions');
        const options = {};
        options.method = 'POST';
        options.body = JSON.stringify({});
        return fetchJson(`${apiUrl}${logoutBackendPath}`, options);
    }
    if (type === AUTH_ERROR) {
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        return localStorage.getItem('username') ? Promise.resolve() : Promise.reject();
    }
    return Promise.reject('Unknown method');
};



// WEBPACK FOOTER //
// ./src/authClient.js